import admin from '../apis/auth.api';
import { GetSubscriptionsUsageResponse } from '../types';

const baseEndpoint = '/subscriptions-usage';

export const getSubscriptionsUsageService =
	(): Promise<GetSubscriptionsUsageResponse> => admin.get(`${baseEndpoint}`);
